import moment from "moment";

export const formatToTime = (date) => {
    if (!date) return "";
    return moment(date).format("HH:mm");
};
